import { DEFAULT_TECHNOLOGIES } from '@src/settings'
import type {
  TechnologyOption,
  TechnologyPageAttributes,
} from '@src/types/siteData'

/**
 * Maps CMS technology pages into contact-form options.
 * Falls back to the sold-product catalogue when Strapi is empty or unusable.
 */
export function mapTechnologyPages(
  entries: { attributes?: TechnologyPageAttributes }[] | undefined,
): TechnologyOption[] {
  if (!entries?.length) {
    return DEFAULT_TECHNOLOGIES
  }

  const technologies = entries
    .map(
      (entry): TechnologyOption => ({
        slug: entry.attributes?.slug ?? null,
        value: entry.attributes?.technologyName ?? '',
      }),
    )
    .filter((option: TechnologyOption) => option.value.length > 0)

  return technologies.length > 0 ? technologies : DEFAULT_TECHNOLOGIES
}
